'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$95() {
  this.bpN = null;
  this.bpO = false;
}
export { $c_Lpresto_PrestoRouter$$anon$95 as $c_Lpresto_PrestoRouter$$anon$95 };
$p = $c_Lpresto_PrestoRouter$$anon$95.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$95;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$95() {
}
export { $h_Lpresto_PrestoRouter$$anon$95 as $h_Lpresto_PrestoRouter$$anon$95 };
$h_Lpresto_PrestoRouter$$anon$95.prototype = $p;
$p.bW = (function() {
  if ((!this.bpO)) {
    this.bpN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bpO = true;
  }
  return this.bpN;
});
$p.P = (function() {
  return this.bW();
});
var $d_Lpresto_PrestoRouter$$anon$95 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$95, "presto.PrestoRouter$$anon$95", ({
  P4: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$95 as $d_Lpresto_PrestoRouter$$anon$95 };
//# sourceMappingURL=presto.-Presto-Router$$anon$95.js.map
